import type { ModuleConfig } from '../types/ship.ts';

export const MODULES_CONFIG: Record<string, ModuleConfig> = {
  // Weapons
  laser_mk1: {
    id: 'laser_mk1',
    name: 'Pháo Laser Xung Kích I',
    category: 'weapon',
    description: 'Chùm tia laser tập trung, xuyên phá mạnh vào lá chắn năng lượng.',
    weight: 20,
    power_draw: 22,
    damage_type: 'energy',
    damage: 48,
    range_phase: 2, // Medium
    accuracy: 85,
    cost: { metal: 40, he3: 35, credits: 10 },
  },
  laser_mk2: {
    id: 'laser_mk2',
    name: 'Pháo Laser Tia Kép II',
    category: 'weapon',
    description: 'Hệ thống chùm tia đồng bộ công suất lớn.',
    weight: 35,
    power_draw: 40,
    damage_type: 'energy',
    damage: 95,
    range_phase: 2,
    accuracy: 88,
    cost: { metal: 90, he3: 80, credits: 25 },
    required_tech: { id: 'laser_tech', level: 2 },
  },
  autocannon_mk1: {
    id: 'autocannon_mk1',
    name: 'Đại Bác Động Năng I',
    category: 'weapon',
    description: 'Bắn liên hoàn đạn vonfram đặc chế, nghiền nát vỏ giáp kim loại.',
    weight: 25,
    power_draw: 15,
    damage_type: 'kinetic',
    damage: 55,
    range_phase: 2,
    accuracy: 80,
    cost: { metal: 50, he3: 15, credits: 10 },
  },
  missile_mk1: {
    id: 'missile_mk1',
    name: 'Tên Lửa Tầm Xa Stalker I',
    category: 'weapon',
    description: 'Khai hỏa từ tầm xa, có khả năng vòng qua hàng trước đánh vào hàng sau.',
    weight: 30,
    power_draw: 20,
    damage_type: 'explosive',
    damage: 75,
    range_phase: 1, // Long
    accuracy: 75,
    cost: { metal: 60, he3: 45, credits: 15 },
    required_tech: { id: 'missile_tech', level: 1 },
  },

  // Shields
  shield_flux_mk1: {
    id: 'shield_flux_mk1',
    name: 'Khiên Từ Trường Flux I',
    category: 'shield',
    description: 'Hấp thụ sát thương trực tiếp từ vũ khí đối phương trước khi chạm vào vỏ tàu.',
    weight: 18,
    power_draw: 25,
    shield_hp: 80,
    cost: { metal: 30, he3: 50, credits: 12 },
  },
  shield_flux_mk2: {
    id: 'shield_flux_mk2',
    name: 'Khiên Từ Trường Cường Lực II',
    category: 'shield',
    description: 'Bộ tạo trường lực đôi với mật độ hạt cao.',
    weight: 32,
    power_draw: 45,
    shield_hp: 180,
    cost: { metal: 70, he3: 110, credits: 30 },
    required_tech: { id: 'shield_tech', level: 2 },
  },

  // Armor
  armor_titan_mk1: {
    id: 'armor_titan_mk1',
    name: 'Giáp Hợp Kim Titan I',
    category: 'armor',
    description: 'Lớp giáp bảo vệ cơ học, giảm sát thương thực nhận và tăng máu.',
    weight: 28,
    power_draw: 5,
    armor_value: 20,
    hp_bonus: 90,
    cost: { metal: 60, he3: 10, credits: 8 },
  },
  armor_titan_mk2: {
    id: 'armor_titan_mk2',
    name: 'Giáp Nano Đa Tầng II',
    category: 'armor',
    description: 'Vật liệu nano tự hàn gắn vi vết nứt khi va chạm đạn đạo.',
    weight: 45,
    power_draw: 8,
    armor_value: 45,
    hp_bonus: 220,
    cost: { metal: 130, he3: 25, credits: 20 },
    required_tech: { id: 'armor_tech', level: 2 },
  },

  // Engines
  engine_ion_mk1: {
    id: 'engine_ion_mk1',
    name: 'Động Cơ Đẩy Ion I',
    category: 'engine',
    description: 'Gia tăng tốc độ né đòn và tốc độ ra tay chiến thuật.',
    weight: 15,
    power_draw: 18,
    speed_bonus: 25,
    evasion_bonus: 5,
    initiative_bonus: 15,
    cost: { metal: 35, he3: 40, credits: 15 },
  },
  engine_ion_mk2: {
    id: 'engine_ion_mk2',
    name: 'Động Cơ Đẩy Xung Lực II',
    category: 'engine',
    description: 'Tối ưu hóa phản lực plasma cho khả năng xoay trở siêu việt.',
    weight: 25,
    power_draw: 32,
    speed_bonus: 50,
    evasion_bonus: 10,
    initiative_bonus: 30,
    cost: { metal: 75, he3: 85, credits: 30 },
    required_tech: { id: 'engine_tech', level: 2 },
  },
};
